const userProfiles = {
    COMMERCIAL: 8,
    RESPONSABLE_AGENCE : 16,
    RESPONSABLE_MULTI_AGENCE : 64,
    ADMINISTRATEUR: 256
}

export default userProfiles;